export const QuestionTypeConstants = {

        // Note: update QuestionTypePickerComponent after adding new question type
        qTypes: [
            {value: 'ST', title: 'Short', label: 'Short Text', image: 'q-screenshot-short.png', fa: 'fa-i-cursor'},
            {value: 'LT', title: 'Essay', label: 'Essay Text', image: 'q-screenshot-essay.png', fa: 'fa-align-left'},
            {value: 'N', title: 'Numerical', label: 'Numerical'},
            {value: 'SC', title: 'Scale', label: 'Scale'},
            {value: 'M1', title: 'Radio', label: 'Pick One Radio Choice'},
            {value: 'M3', title: 'Select', label: 'Pick One List Choice'},
            {value: 'M2', title: 'Multiple', label: 'Pick Multiple Choices'},
            {value: 'T1', title: 'Table Radio', label: 'Pick One Choice Table'},
            {value: 'T2', title: 'Table Multiple', label: 'Pick Multiple Choices Table'},
        ],

        questionHas: {
            ST: {},    // "Short Text"
            LT: {},    // "Long Text Essay"
            SC: {hasAnswer: true},    // "Scale"
            N: {hasAnswer: true},     // "Numerical"
            M1: {hasAnswer: true, hasChoices: true},    // "Pick One Radio Choice"
            M2: {hasAnswers: true, hasChoices: true},   // "Pick One List Choice"
            M3: {hasAnswer: true, hasChoices: true},    // "Pick Multiple Choices" (no correctAnswers)
            T1: {hasAnswer: true, hasChoices: true, hasSubquestions: true},    // "Pick One Choice Table"
            T2: {hasAnswers: true, hasChoices: true, hasSubquestions: true}     // "Pick Multiple Choices Table"  (no correctAnswers)
        },

        choicesLabelTypeCodes: [
            {value: '0', label: 'None'},
            {value: 'A', label: 'Alpha (A., B., ...)'},
            {value: '#', label: 'Numeric (1., 2., ...)'}
        ],

        subquestLabelTypeCodes: [],//: this.choicesLabelTypeCodes

        questionMultiTypes: {'M2': 1, 'T2': 1},

        isMultipleType: function (questionType: string): boolean {
            return QuestionTypeConstants.questionMultiTypes[questionType];
        }


    }
;

QuestionTypeConstants.subquestLabelTypeCodes = QuestionTypeConstants.choicesLabelTypeCodes;

export const AuthorMetaConstants = {

    questionMetadata: {
        questNum: {type: 'number'},
        questTypeCode: {type: 'set', required: true},
        questLabel: {type: 'string'},
        preText: {type: 'string'},
        postText: {type: 'string'},
        text: {type: 'string', required: true},
        shortTextLimit: {type: 'number', required: true, min: 1, max: 500},
        scaleMaxValue: {type: 'string', required: true, min: 1, qTypes: 'SC'},
        choicesLabelTypeCode: {type: 'string', qTypes: 'M1,M2'},
        mustAnswerFlag: {type: 'boolean', required: true},
        otherResponseFlag: {type: 'boolean', required: true, qTypes: 'M1,M2,M3,T1,T2'},
        otherResponseTextLimit: {type: 'number', required: true, min: 1, max: 500, qTypes: 'M1,M2,M3,T1,T2'},
        subquestLabelTypeCode: {type: 'string', required: true, qTypes: 'T1,T2'},
        initialValue: {type: 'string', required: false, qTypes: 'ST'},
    },

    /**
     * reducer - function that returns 'back-end' value from UI
     * required - value must be non-blank
     * type - field type
     */
    pollMetadata: {
        pollId: {type: 'number', required: true},
        prsnId: {type: 'number', required: true},
        pollTitle: {type: 'string', required: true},
        preText: {type: 'string'},
        postText: {type: 'string'},
        topgifUrl: {type: 'string'},
        endpollUrl: {type: 'string'},
        customPollUrl: {type: 'string'},
        styleSheetUrl: {type: 'string'},

        questSetNums: {type: 'number'},

        timeLimit: {type: 'number', reducer: (val) => val == '' || val <= 0 ? -1 : val},

        anonymity: {type: 'number'},

        resultsAvailableFlag: {type: 'boolean'},
        mustAnswerAllFlag: {type: 'boolean'},
        multipleResponsesFlag: {type: 'boolean'},
        selfTestFlag: {type: 'boolean'},
        pollResponseEditableFlag: {type: 'boolean', required: true},
        hasCorrectAnswersFlag: {type: 'boolean', required: true},
        previewResponsesFlag: {type: 'boolean'},

        publishedFlag: {type: 'boolean'},
        scriptRequiredFlag: {type: 'boolean'},

        openDate: {type: 'date'},
        closeDate: {type: 'date'},
        resultsDate: {type: 'date'},

        themeTypeCode: {type: 'string'}
    }
};

export const VariablesDesc = [
    {value: '', label: 'None'},
    {value: 'legalFirst', label: 'Legal First Name'},
    {value: 'legalLast', label: 'Legal Last Name'},
    {value: 'legalMiddle', label: 'Legal Middle Name'},
    {value: 'legalSuffix', label: 'Legal Suffix'},
    {value: 'preferredFirst', label: 'Preferred First Name'},
    {value: 'preferredLast', label: 'Preferred Last Name'},
    {value: 'huid', label: 'HUID'},
    {value: 'email', label: 'Email'},
    {value: 'section', label: 'MBA Section'},
    {value: 'jointDegree', label: ' Joint Degree Program'}
];

